export interface WorkerAccount {
  id: number;
  name: string;
  screen_id: string;
}

// すでに物件へ登録されている作業者かどうかを判定する
export function isAccountRegistered(registeredAccountIds: number[], accountId: number): boolean {
  if (registeredAccountIds.indexOf(accountId) !== -1) {
    return true;
  }
  return false;
}

// 一覧の行をクリックしたときの選択状態を作る。登録済みの作業者は選べない
export function toggleAccountSelection(selectedAccountIds: number[], accountId: number, registeredAccountIds: number[]): number[] {
  if (isAccountRegistered(registeredAccountIds, accountId)) {
    return selectedAccountIds;
  }
  if (selectedAccountIds.indexOf(accountId) !== -1) {
    return selectedAccountIds.filter(selectedAccountId => selectedAccountId !== accountId);
  }
  return selectedAccountIds.concat([accountId]);
}

// まだ登録されていない作業者だけを、元の並び順のまま取り出す
export function getAvailableWorkerAccounts(workerAccounts: WorkerAccount[], registeredAccountIds: number[]): WorkerAccount[] {
  return workerAccounts.filter(workerAccount => !isAccountRegistered(registeredAccountIds, workerAccount.id));
}

// 一人ずつ追加するプルダウンで最初に選ばれる作業者を決める
export function getNextSelectedAccountId(workerAccounts: WorkerAccount[], registeredAccountIds: number[]): number | undefined {
  const availableWorkerAccounts = getAvailableWorkerAccounts(workerAccounts, registeredAccountIds);
  if (availableWorkerAccounts.length > 0) {
    return availableWorkerAccounts[0].id;
  }
  return undefined;
}

// 登録済みの一覧の末尾へ、重複しない作業者だけを追加する
export function appendWorkerAccounts(currentAccounts: WorkerAccount[], accountsToAdd: WorkerAccount[]): WorkerAccount[] {
  const nextAccounts = currentAccounts.slice();
  accountsToAdd.forEach(accountToAdd => {
    const isAlreadyIncluded = nextAccounts.findIndex(nextAccount => nextAccount.id === accountToAdd.id) !== -1;
    if (!isAlreadyIncluded) {
      nextAccounts.push(accountToAdd);
    }
  });
  return nextAccounts;
}

// 選択された作業者のうち、まだ登録されていない人だけを候補一覧の並び順で取り出す
export function getAccountsToAdd(workerAccounts: WorkerAccount[], selectedAccountIds: number[], registeredAccountIds: number[]): WorkerAccount[] {
  return workerAccounts.filter(workerAccount => {
    const isSelected = selectedAccountIds.indexOf(workerAccount.id) !== -1;
    if (isSelected) {
      return !isAccountRegistered(registeredAccountIds, workerAccount.id);
    }
    return false;
  });
}

// 一覧の行の見た目を、登録済みか選択中かで切り替える
export function getWorkerRowClassName(isRegistered: boolean, isSelected: boolean): string {
  if (isRegistered) {
    return 'WorkerBulkAddDialog-row WorkerBulkAddDialog-row-registered';
  }
  if (isSelected) {
    return 'WorkerBulkAddDialog-row WorkerBulkAddDialog-row-selected';
  }
  return 'WorkerBulkAddDialog-row';
}
